import * as React from "react"

export const FeatherIcon: React.FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 2C19.9773 2.13906 5.76703 3.49219 4.77366 13.2348C4.65296 14.2762 4.5846 15.3223 4.53967 16.3692L11.5269 9.3891C11.771 9.14496 12.1675 9.14496 12.4116 9.3891C12.6558 9.63324 12.6558 10.0289 12.4116 10.2731L2.27481 20.3997C1.9084 20.7657 1.9084 21.3595 2.27481 21.7255C2.64122 22.0915 3.23536 22.0915 3.60216 21.7255L5.83383 19.4962C7.47798 19.4907 9.12097 19.3974 10.7542 19.2087C12.8433 18.9962 14.5441 18.1747 15.9331 17.0001H11.9897L17.7238 15.0907C18.1632 14.509 18.5586 13.8911 18.9133 13.2501H15.7437L19.9054 11.1715C21.5426 7.18987 21.9293 3.02579 22 2Z"
      fill="#616161"
    />
  </svg>
)
